export default __webpack_public_path__ + "static/media/wh_icon_wp.699ea6ce.svg";